module.exports = require("babel-runtime/helpers/createClass");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/createClass"
// module id = 49
// module chunks = 0